import { namespace as createVuexClass } from 'vuex-class';
import { InlineResponse200 } from 'ctp-filter-group-management';

export const namespace = 'groupManagement';
export const store = createVuexClass(namespace);

export const FETCH_FILTER_GROUPS = 'fetchFilterGroups';
export const CREATE_FILTER_GROUP = 'createFilterGroup';
export const DELETE_FILTER_GROUP = 'deleteFilterGroup';
export const EDIT_FILTER_GROUP = 'editFilterGroup';
export const UPDATE_GROUPS_STATE = 'updateGroupsState';
export const FILTER_GROUP_NAVIGATION = 'filterGroupNavigation';
export const USER_SELECTION_REGISTER_GROUP = 'userSelectionRegisterGroup';
export const USER_SELECTION_CLEAR_GROUPS = 'userSelectionClearGroups';
export const USER_SELECTION_RESET_ACTIONS = 'userSelectionResetActions';
export const TRIGGER_GROUP_USER_SELECTION_ACTION = 'triggerGroupUserSelectionAction';
export const UPDATE_NAVIGATION = 'updateNavigation';
export const SET_ERROR = 'setError';
export const REINIT = 'reinit';
export const FETCH_TOTAL_GROUPS = 'fetchTotalGroups';

export interface IGroupsState {
  [view: string]: boolean;
}

export interface IGroupsStatePayload {
  stateKey: string;
  view: string;
  stateValue: boolean;
}

export interface IDevicesGroupsState {
  [state: string]: IGroupsState;
}

export interface INavigation {
  start: number;
  groupsPerPage: number;
  direction: 'backward' | 'forward';
  isLastGroupPage: boolean;
}

export interface IGroupsActions {
  label: string;
  enabled: boolean;
}

export interface IUserSelection {
  groups: string[];
  actions: {
    [key: string]: IGroupsActions;
  };
}

export interface GroupManagementState {
  groupsComponentsState: IDevicesGroupsState;
  groups: InlineResponse200;
  navigation: INavigation;
  total: number;
  errorMessage: string; // last error
  userSelection: IUserSelection;
}
